export default __webpack_public_path__ + "static/footer-icon-en-c98166fbe0701e2b9910ba2d3282378c.jpg";